<div class="wrapper cv-dialog-form organization-container">
	<div class="row" *ngIf="integrationParams?.hasTabs">
		<cv-editable-tabs 
			#editableTabsComponent 
			[config]="integrationParams.tabsConfiguration">
		</cv-editable-tabs>
	</div>
	<div class="row" *ngIf="!integrationParams?.hasTabs">
		<ng-container *ngFor="let formField of formFields">
			<div class="{{formField.customClass}}">
				<cv-form-field *ngIf="showFields" [options]="{
                        path: formField.path,
                        label: formField.label
                    }" [model]="formBuilderConfig[formField.key]">
				</cv-form-field>
			</div>
		</ng-container>
	</div>
</div>